import { PetitionsHistoryResponse } from '../types';
import { Icon } from '@octano/global-ui';
import dayjs from 'dayjs';
import { TextEllipsis } from '../../../../../components/text';
import PetitionStatusBadge from '../../../../../components/badgeStatus/PetitionStatusBadge';
import IconOptionPetitionsPayment from '../../../../StudentsPetitionsList/parts/IconOptionPetitionsPayment';

export function useColumns(
  data: PetitionsHistoryResponse['petitions']['data'],
  openModal: Function,
) {
  return data.map((petition) => {
    return {
      folio: petition.folio,
      createdAt: dayjs(petition.createdAt).format('DD/MM/YYYY'),
      studyPlanVersionName: (
        <TextEllipsis
          key={petition.folio}
          textWidth={300}
          style={{ margin: 0 }}
        >
          {petition.studyPlanVersionName}
        </TextEllipsis>
      ),
      typeName: petition.typeName,
      title: petition.title,
      status: (
        <PetitionStatusBadge status={petition.status} name={petition.folio} />
      ),
      paymentStatus: petition.paymentStatus ? (
        <IconOptionPetitionsPayment statusPayment={petition.paymentStatus} />
      ) : (
        <></>
      ),

      viewDetail: (
        <span
          onClick={(e) => openModal(petition.folio)}
          className="cursor-pointer"
        >
          <Icon className="custom-eye" name="eye" key="eye" size="22px" />
        </span>
      ),
    };
  });
}
